const LIB_PREFIX = 'hm';
module.exports = { LIB_PREFIX };
